export {
  I18nextProvider,
  withNamespaces,
  NamespacesConsumer,
  translate,
} from 'react-i18next'

export { default } from './src/instance'
